<div>
    <mat-dialog-content>
      <div class="content">
        <div class="header-container">
          <h3>{{ data.header}}</h3>
          <mat-icon svgIcon="info"></mat-icon>
        </div>
        <span class="card-subtitle t4 mb-2 mt-2 text-muted">{{ data.error }}</span>
      </div>
      <mat-divider></mat-divider>
      <div class="button-container">
        <button class="btn button btn-primary btn-block col-6" mat-button [mat-dialog-close]="true"
          cdkFocusInitial>
          CONFIRM
        </button>
      </div>
    </mat-dialog-content>
  </div>
